
import { useEffect, useState } from 'react';
import { fetchMeterQuality } from '../services/meter.api';

export function useMeterQuality(meterNumber, dateRange, evn) {
  const [qualityData, setQualityData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!meterNumber) return;
    let alive = true;

    (async () => {
      try {
        setLoading(true);
        const json = await fetchMeterQuality(meterNumber, {
          fromDate: dateRange?.start,
          toDate: dateRange?.end,
          evn,
        });
        if (!alive) return;
        setQualityData(Array.isArray(json) ? json : []);
      } catch (err) {
        if (!alive) return;
        console.error('useMeterQuality:', err);
        setQualityData([]);
      } finally {
        if (alive) setLoading(false);
      }
    })();

    return () => { alive = false; };
  }, [meterNumber, dateRange?.start, dateRange?.end, evn]);

  return { qualityData, loading };
}
